<template>
  <div class="privacy">
    <div class="border borderColordarkgray2 rounded overflow-hidden px-4 md:px-8 py-6 md:py-8 tracking-wider leading-loose">
      <div class="service">

        <div class="privacy-body">
          <h5 class="text-NotoSansRegular text-sm">「LiveABC互動英語教學集團」網站（下稱LiveABC網站）為「希伯崙股份有限公司」（下稱本公司）所經營；為維護個人隱私權，依中華民國頒立之「個人資料保護法」第8條規定，本公司謹以下列聲明，向LiveABC集團數位平台使用者或會員說明LiveABC集團數位平台，蒐集個人資料之目的、類別、利用範圍及方式、以及您得行使之權利等事項。</h5>
          <ul class="list-inside my-6 text-NotoSansRegular text-sm">
            <li>LiveABC網站對使用者或會員個人資料的收集，謹遵守中華民國「個人資料保護法」與相關法令之規範。</li>
            <li>當您註冊、使用、瀏覽LiveABC網站，成為網站會員或參與網站宣傳或抽獎等相關活動時，表示您已閱讀、瞭解並同意接受本隱私權聲明之所有內容。本公司有權修改或變更LiveABC網站隱私權聲明之內容，建議您隨時注意本隱私權聲明修改或變更內容資訊。如您於本隱私權內容有修改或變更後，繼續使用LiveABC網站服務，則視為已閱讀、瞭解並同意接受該次修改或變更內容。如您不同意本隱私權聲明內容，或者您所屬國家或地域排除本隱私權內容之全部或一部分時，應立即停止使用本服務。</li>
            <li>當您使用LiveABC網站或註冊為LiveABC網站會員以訂閱電子報、購書、訂閱雜誌及使用相關服務或參加其他活動時，本公司於完成與您聯繫、完成交易、解決客訴、或處理訂閱程序之相關範圍內，會要求您提供個人資料（包括個人姓名、地址、e-mail、聯絡方式等）。您可以自由選擇是否提供個人資料，但拒絕提供加入會員所需必要之資料，將可能導致您無法使用該項服務，對此本公司不負擔任何賠償責任。</li>
            <li>於網路購物、行銷推廣、物流服務、帳務服務、客戶管理及服務或其他合於營業登記項目或章程所訂業務需要之目的範圍內，LiveABC網站將藉由加入會員之過程或進行交易之過程來蒐集、處理、及利用您的個人資料，包括姓名、地址、e-mail、連絡方式、信用卡號等，並對您發送活動訊息、商品優惠訊息、廣告等相關服務。為了確保會員之個人資料、隱私及消費者權益之保護，依個人資料保護法，本公司將以電郵、傳真、電話、簡訊或其他通知公告方式利用您所提供之資料（資料類別C001、C002、C003、C011等各項類別相關資料）。利用對象除本公司外，亦可能包括相關服務的協力機構。除會員有反對之表示，LiveABC網站得於會員入會期間內，利用會員之個人資料。LiveABC網站對所蒐集之資料依法保密。會員有請求停止蒐集、處理、利用或請求刪除之權利，辦理方式為電話通知客服中心處理(02)2578-7838。</li>
            <li>為了便利使用者，LiveABC網站可能使用cookie設定及技術，以便於提供更適合使用者個人需要的服務；cookie是網站伺服器用來和使用者瀏覽器進行溝通的一種技術，它可能在使用者的電腦中儲存某些資訊，您可以自由地經由瀏覽器的設定，取消、或限制此項功能。但這可能會導致網站某些功能無法正常執行，對此本公司不負擔任何賠償責任。</li>
            <li>您對於因使用LiveABC網站或註冊為LiveABC網站會員所提供之個人資料，有查詢及閱覽、製給複製本、補充或更正、停止電腦處理及利用、刪除等需求時，可以與客服中心聯絡，LiveABC網站將迅速進行處理。</li>
            <li>如果您對LiveABC網站的隱私權聲明有任何疑問，歡迎您以電話或電子郵件與客戶服務中心聯絡。<br/>
              客服信箱：service@liveabc.com 【服務時間：24小時】<br/>
              客服專線：（02）2578-7838【服務時間：週一至週五9:00~17:30】
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  metaInfo () {
    return {
      title: '隱私權政策',
      titleTemplate: null
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    list-style-type: cjk-ideographic;
    li {
      margin-bottom: 1rem;
    }
  }
</style>
